import { useContext, useEffect } from 'react'
import { CustomComponentContext, CustomComponentContextType } from '@/utils/contexts/CustomComponentContext'
import { UserService } from '@/api/user'
import { Controller } from 'react-hook-form'
import { Input } from 'alurkerja-ui'

// eslint-disable-next-line react-refresh/only-export-components
export const specJobPosition = [
  {
    form_field_type: 'CUSTOM_COMPONENT',
    label: 'Job Position',
    name: 'jobPosition',
    type: 'text',
  },
]

export default function JobPosition() {
  const { setValue, taskData, control } = useContext<CustomComponentContextType>(CustomComponentContext)
  const { data: userData } = UserService.useGetProfile()

  const classNamesLabel = 'after:text-sm font-medium'

  useEffect(() => {
    if (userData) {
      setValue('jobPosition', userData.role)
    }
  }, [userData, setValue])

  return (
    <div className="grid grid-cols-2 space-x-2">
      <div>
        <label htmlFor="jobPosition" className={classNamesLabel}>
          Job Position
        </label>
        <Controller
          name={'jobPosition'}
          control={control}
          render={() => {
            return (
              <>
                <Input value={userData?.role ?? ''} defaultValue={taskData?.variables?.jobPosition ?? null} disabled />
              </>
            )
          }}
        ></Controller>
      </div>
    </div>
  )
}
